import React from 'react';
import c from 'classnames';
import s from './VerticalLayout.scss';
const VerticalLayout = ({ children, className })=>/*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, children);
VerticalLayout.displayName = 'VerticalLayout';
export default VerticalLayout;

//# sourceMappingURL=VerticalLayout.js.map